import { Action } from "redux";
import {
  RESET_SEARCH_RESULTS,
  SEARCH_OBJECT_REQUEST_SUCCESS,
  SearchResult,
  SearchResultAction,
} from "../actions/search";

export interface SearchState {
  results: SearchResult[] | undefined;
}

const defaultState = {
  results: undefined,
};

export function searchReducer(state = defaultState, action: Action) {
  switch (action.type) {
    case SEARCH_OBJECT_REQUEST_SUCCESS:
      return handleSearchObjectRequestSuccess(
        state,
        action as SearchResultAction
      );
    case RESET_SEARCH_RESULTS:
      return handleResetSearchResults(state, action);
  }

  return state;
}

function handleSearchObjectRequestSuccess(
  state: SearchState,
  action: SearchResultAction
) {
  const newState = { ...state };

  newState.results = action.results;

  return newState;
}

function handleResetSearchResults(state: SearchState, action: Action) {
  const newState = { ...state };

  newState.results = undefined;

  return newState;
}
